import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GalleryComponent } from './gallery.component';
import {ListGalleryComponent} from './list/list.component';

const routes: Routes = [
    { path: '', component: GalleryComponent },
    { path: 'galerias', component: ListGalleryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GalleryRoutingModule { }
